import { createContext, useEffect, useState } from "react";
import Lenis, { LenisOptions } from "lenis";
import type { PropsWithChildren } from "react";
import { smoothScroller } from "../smooth-scroller";

export interface LenisContextValue {
  lenis: Lenis | null;
}

export const LenisContext = createContext<LenisContextValue>({
  lenis: null,
});

export const LenisProvider = ({
  children,
  watch,
  options,
}: PropsWithChildren<{
  watch?: string;
  options?: Omit<LenisOptions, "wrapper" | "content">;
}>) => {
  const [lenis, setLenis] = useState<Lenis | null>(null);

  useEffect(() => {
    const wrapper = document.querySelector("[data-lenis-wrapper]");
    const content =
      wrapper?.querySelector("[data-lenis-container]") ||
      wrapper?.firstElementChild ||
      null;

    let instance: Lenis;
    if (wrapper && content) {
      instance = smoothScroller.rebind({ wrapper, content, ...options });
    } else {
      instance = smoothScroller.rebind({ ...options });
    }

    setLenis(instance);

    return () => {
      instance.destroy();
      smoothScroller.setInstance(null);
    };
  }, [watch]);

  return (
    <LenisContext.Provider value={{ lenis }}>{children}</LenisContext.Provider>
  );
};
